import { mutatorAction } from 'satcheljs';
import { type MailboxInfo } from 'owa-client-types';
import { getTimestamp, now } from 'owa-datetime';
import { getAsyncItemRegistry } from '../selectors/getAsyncItemRegistry';
import type { AsyncItemStatus } from 'owa-copilot-async-chat-types';

/** Updates the live status of a single async item. No-op if the entry is not tracked. */
export const setAsyncItemStatusMutator: (
    mailboxInfo: MailboxInfo,
    id: string,
    status: AsyncItemStatus
) => void = mutatorAction('setAsyncItemStatusMutator', (mailboxInfo, id, status) => {
    const entry = getAsyncItemRegistry(mailboxInfo)?.entriesById.get(id);
    if (!entry) {
        return;
    }

    if (entry.status !== status) {
        entry.statusChangedAtTimestampMs = getTimestamp(now());
        entry.status = status;
    }
});
